import { Routes } from '@angular/router';
import { MainLayout } from './layout/main-layout/main-layout';
import { authGuard } from './services/guards/auth-guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },

  {
    path: 'login',
    loadComponent: () => import('./layout/login/login').then((m) => m.Login),
  },

  {
    path: '',
    component: MainLayout,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'claim-intake',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./components/dashboard/dashboard').then((m) => m.DashboardComponent),
      },

      // CLAIM INTAKE
      {
        path: 'claim-intake',
        loadComponent: () =>
          import('./components/claim-intake/claim-intake').then((m) => m.ClaimIntakeComponent),
      },

      // REQUESTS
      {
        path: 'requests',
        loadComponent: () =>
          import('./components/requests/requests').then((m) => m.RequestsComponent),
      },

      // EDGE MATTERS
      {
        path: 'edge-matters',
        loadComponent: () =>
          import('./components/edge-matters/edge-matter-board/edge-matters-board').then(
            (m) => m.EdgeMattersBoard,
          ),
      },

      // ACTIVITY
      {
        path: 'activity',
        loadComponent: () =>
          import('./components/activity/activity').then((m) => m.Activity),
      },

      // MATTER NOTES
      {
        path: 'matter-notes',
        loadComponent: () =>
          import('./components/matter-notes/matter-notes').then((m) => m.MatterNotesComponent),
      },

      // EDGE FILES
      {
        path: 'edge-files',
        loadComponent: () =>
          import('./components/edge-files/edge-files').then((m) => m.EdgeFilesComponent),
      },

      // RESOURCES
      {
        path: 'resources',
        loadComponent: () =>
          import('./components/resources/resources').then((m) => m.ResourcesComponent),
      },

      // ADMIN
      {
        path: 'admin',

        canActivate: [authGuard],

        data: {
          roles: ['admin'],
        },

        loadComponent: () => import('./components/admin/admin').then((m) => m.Admin),

        children: [
          {
            path: '',
            redirectTo: 'users',
            pathMatch: 'full',
          },

          {
            path: 'users',
            loadComponent: () =>
              import('./components/admin/user-management/user-management').then(
                (m) => m.UserManagement,
              ),
          },
        ],
      },
    ],
  },
  // WILDCARD
  {
    path: '**',
    redirectTo: 'login',
  },
];
